import { render, staticRenderFns } from "./WidgetColumnValue.vue?vue&type=template&id=68313692"
import script from "./WidgetColumnValue.vue?vue&type=script&lang=js"
export * from "./WidgetColumnValue.vue?vue&type=script&lang=js"
import style0 from "./WidgetColumnValue.vue?vue&type=style&index=0&id=68313692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports